import React from 'react'
import { Loader } from '@mantine/core';

const Button = ({label,className,style,onClick,loading,disabled}) => {
  return (
    <button
      disabled={loading ? (loading === true ? true : false ) : (disabled ? true : false)} 
      onClick={onClick} 
      style={style} 
      className={`bg-mainBlue text-white flex justify-center items-center font-[500] px-10 py-2 rounded-md ${loading && (loading === true ? 'bg-opacity-50' : 'bg-opacity-100')} ${disabled === true ? 'bg-opacity-50' : 'bg-opacity-100'} ${className}`}
    >
      {loading ? <Loader size={27} /> : label}
    </button>
  )
}

export default Button